import axios from "axios";
import { getSessionToken } from "@shopify/app-bridge-utils";
import Alert from "./Alert";

const instance = axios.create();
instance.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
instance.defaults.withCredentials = true;

if (window.app) {
    instance.interceptors.request.use(
        async (config) => {
            try {
                const token = await getSessionToken(window.app);
                config.headers!["Authorization"] = `Bearer ${token}`;
            } catch (error) {
                console.error("Failed to retrieve session token:", error);
            }
            return config;
        }
    );


    instance.interceptors.response.use(
        async (response) => response,
        async (error) => {
            switch (error.response?.status) {
                case 401:
                    console.log("ESC Unauthorised");
                    break;
                case 403:
                    console.log("ESC Forbidden!");
                    break;
                case 500:
                    console.log("ESC Something went wrong!");
                    break;
                case 422:
                    console.log("ESC Validation error");
                    break;
                default:
                    console.error("ESC Unexpected error:", error);
            }

            return Promise.reject(error);
        }
    );
}

export default instance;